import { Alert, Divider, Text } from "@amzn/storm-ui";
import React from "react";
import { useStore } from "zustand";

import { dimensionHydrationStore } from "../../../store/dimension.hydration";
import { LoadingSpinner } from "../../LoadingSpinner";

export interface HydrationPromptProps {
    requiresHydration?: boolean;
    isHydrationDone?: boolean;
    hydrationErrorMessages: [string, string, string, string][];
}

export const HydrationPrompt: React.FC<HydrationPromptProps> = (props) => {
    const [dismissedHydrationMessages, setDismissedHydrationMessages] =
        React.useState<boolean>(false);
    const { isHydrationDone, requiresHydration, hydrationErrorMessages } =
        props;

    const [currentDimensions] = useStore(dimensionHydrationStore, (state) => [
        state.currentDimensions,
    ]);

    if (!requiresHydration || dismissedHydrationMessages) return null;

    if (!isHydrationDone) return <LoadingSpinner prompt="Populating Inputs" />;

    return (
        <>
            {hydrationErrorMessages.length > 0 ? (
                <>
                    <Alert
                        variant="info"
                        header="We couldn't restore your previous selections:"
                        onClose={() => setDismissedHydrationMessages(true)}
                        withCloseButton={true}
                    >
                        <Text>Please reselect the following:</Text>
                        {hydrationErrorMessages.map(
                            ([_id, dimension, cause]) => (
                                <div>
                                    <Text key={dimension} size="small">
                                        {currentDimensions[dimension]
                                            ? currentDimensions[dimension]
                                                  .configuration.label
                                            : dimension}
                                    </Text>
                                </div>
                            ),
                        )}
                    </Alert>
                    <Divider />
                </>
            ) : (
                <>
                    <Alert
                        variant="success"
                        header="Successfully populated inputs"
                        onClose={() => setDismissedHydrationMessages(true)}
                        withCloseButton={true}
                    ></Alert>
                    <Divider />
                </>
            )}
        </>
    );
};
